"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pl_1 = __importDefault(require("date-fns/locale/pl")); //
const datePlPL = {
    name: 'pl-PL',
    locale: pl_1.default
};
exports.default = datePlPL;
